import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppContainerState, User, Account } from '../../domains/app';

export const appSlice = createSlice({
  name: 'app',
  initialState: {
    user: null,
  } as AppContainerState,
  reducers: {
    setUser: (state, action: PayloadAction<User>) => {
      state.user = action.payload;
    },
    setSelectedAccount: (state, action: PayloadAction<Account | undefined>) => {
      state.selectedAccount = action.payload;
    },
  },
});

export const { setUser, setSelectedAccount } = appSlice.actions;

export default appSlice.reducer;
